(() => {
  "use strict";
  const RT =
    window.BienestarRuntime ||
    (window.BienestarRuntime = (() => {
      const defs = new Map();
      const roots = (target, selector) => {
        const found = [];
        if (target?.nodeType !== 1 && target !== document) return found;
        if (target !== document && target.matches?.(selector))
          found.push(target);
        target.querySelectorAll?.(selector).forEach((node) => found.push(node));
        return found;
      };
      const mount = (def, root) => {
        if (def.instances.has(root)) return;
        const cleanups = [];
        const onCleanup = (fn) => {
          if (typeof fn === "function") cleanups.push(fn);
        };
        try {
          onCleanup(def.setup(root, onCleanup));
        } catch (error) {
          console.error("[Bienestar]", def.name, error);
        }
        def.instances.set(root, () => {
          for (let i = cleanups.length - 1; i >= 0; i--)
            try {
              cleanups[i]();
            } catch {}
          def.instances.delete(root);
          def.mounted.delete(root);
        });
        def.mounted.add(root);
      };
      const unmount = (def, target) => {
        for (const root of [...def.mounted])
          if (root === target || target.contains?.(root))
            def.instances.get(root)?.();
      };
      const load = (event) =>
        defs.forEach((def) =>
          roots(event.target, def.selector).forEach((root) => mount(def, root)),
        );
      const unload = (event) =>
        defs.forEach((def) => unmount(def, event.target));
      addEventListener("shopify:section:load", load);
      addEventListener("shopify:section:unload", unload);
      return {
        define(name, selector, setup) {
          const previous = defs.get(name);
          if (previous)
            for (const root of [...previous.mounted])
              previous.instances.get(root)?.();
          const def = {
            name,
            selector,
            setup,
            instances: new WeakMap(),
            mounted: new Set(),
          };
          defs.set(name, def);
          roots(document, selector).forEach((root) => mount(def, root));
          return def;
        },
        snapshot() {
          return Object.fromEntries(
            [...defs].map(([name, def]) => [name, def.mounted.size]),
          );
        },
      };
    })());
  RT.define("proceso", '[data-bienestar-section="proceso"]', (root) => {
    if (
      matchMedia("(prefers-reduced-motion: reduce)").matches ||
      !("IntersectionObserver" in window)
    )
      return;
    const section = root.querySelector("[data-subscription-process]"),
      steps = [...root.querySelectorAll("[data-process-step]")],
      progress = root.querySelector("[data-process-progress]");
    let furthest = -1;
    section?.classList.add("is-motion-ready");
    const observer = new IntersectionObserver(
      (entries) =>
        entries
          .filter((e) => e.isIntersecting)
          .forEach((e) => {
            e.target.classList.add("is-visible");
            furthest = Math.max(furthest, steps.indexOf(e.target));
            if (progress)
              progress.style.transform = `scaleY(${(furthest + 1) / steps.length})`;
            observer.unobserve(e.target);
          }),
      { threshold: 0.15 },
    );
    steps.forEach((node) => observer.observe(node));
    return () => observer.disconnect();
  });
})();
